import React from "react";
import svg164 from "../../../../assets/svg/svg164.svg";
import { Form, Select } from "antd";
import AccountNumber from "./AccountNumber";
import { useSelector } from "react-redux";

function SelectCompany({ form }) {
  const urlWtrCompany = "api/v1/public/fetch-paybills";
  const { loading, dataWtrCompany } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataWtrCompany: state.fetch.data[urlWtrCompany] || [],
  }));

  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] mt-[1rem]">
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-[0.5rem]">
          <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-[#EDEDF1] flex items-center justify-center">
            <img src={svg164} alt="svg164" />
          </div>
          <span className="text-[#1E191B] font-[500] font-lexendS text-[1rem] leading-[1.5rem]">
            Select Your Company
          </span>
        </div>

        <div className="py-[0.125rem] px-[0.5rem] rounded-[624.9375rem] bg-[#EDEDF1] text-[#4F4770] text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
          Step 1/3
        </div>
      </div>

      <Form.Item
        name="pbId"
        className="mt-[.5rem]"
        label={<span>Company Name</span>}
        rules={[
          {
            required: true,
            message: "Please select a company from the list.",
          },
        ]}
      >
        <Select
          placeholder="Select or Start typing company name..."
          className=""
          allowClear
          style={{
            width: "100%",
          }}
          options={dataWtrCompany?.map((item) => ({
            value: item?.pbId,
            searchText: `${item?.pbName} ${item?.pbDesc} ${item?.pbPaybill}`,
            label: (
              <div className="flex items-center gap-[0.5rem] py-[0.25rem]">
                <div className="w-[2.5rem] h-[2.5rem] flex-shrink-0 rounded-[0.375rem] flex items-center justify-center overflow-hidden">
                  <img src={item?.pbIcon ?? svg164} alt="icon" className="w-full h-full object-contain p-[0.15rem]" />
                </div>
                <div className="flex flex-col min-w-0">
                  <span className="text-[0.8125rem] font-[500] text-[#0F172A] truncate">{item?.pbName}</span>
                  <span className="text-[0.6875rem] text-[#7A7493] truncate">{item?.pbDesc} · {item?.pbType} : {item?.pbPaybill}</span>
                </div>
              </div>
            ),
          }))}
          showSearch
          optionFilterProp="searchText"
        />
      </Form.Item>
    </div>
  );
}

export default SelectCompany;
